import React from 'react';
import CloseObject from '../../common/poppers/CloseObject';
import DeleteObject from '../../common/poppers/DeleteObject';
import BankAccountRow from './BankAccountRow';
import ModifyBankAccountNumber from './ModifyBankAccountNumber';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';

export const bankAccountNumberActionItems = [
    {
        dataDialog: "modify-dialog",
        title: "Módosít",
        dialogTitle: "Bankszámlaszám módosítása",
        icon: <EditIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <ModifyBankAccountNumber  {...props} close={close} />
    },
    {
        dataDialog: "close-dialog",
        title: "Lezárás",
        dialogTitle: "Biztos hogy le szeretnéd zárni?",
        icon: <CancelOutlinedIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <CloseObject {...props} close={close} path={'/api/bankaccountnumber/close'} datePickerlabel={'Érvényesség vége'} />
    },
    {
        divider: true,
    },
    {
        dataDialog: "delete-dialog",
        title: "Törlés",
        dialogTitle: "Biztos hogy törölni szeretnéd?",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/bankaccountnumber'} comp={<BankAccountRow {...props} />} />
    },
]